import { Tournament } from '../services/api';

interface AuthUser {
  userId?: string;
  'custom:role'?: string;
}

/**
 * Checks if a user can manage a specific tournament
 * @param user - The current authenticated user
 * @param tournament - The tournament to check
 * @returns true if user can manage the tournament
 */
export const canManageTournament = (user: AuthUser | null, tournament: Tournament | null): boolean => {
  if (!user || !tournament) return false;

  // Admins can manage all tournaments
  if (user['custom:role'] === 'admin') {
    return true;
  }

  // Tournament managers can manage tournaments they created or are assigned to
  if (user['custom:role'] === 'tournament_manager') {
    // Check if user created the tournament
    if (tournament.created_by === user.userId) {
      return true;
    }

    // Check if user is in the manager list
    if (tournament.manager_user_ids && tournament.manager_user_ids.includes(user.userId || '')) {
      return true;
    }
  }

  return false;
};

/**
 * Checks if a user can create tournaments
 * @param user - The current authenticated user
 * @returns true if user can create tournaments
 */
export const canCreateTournament = (user: AuthUser | null): boolean => {
  if (!user) return false;
  return user['custom:role'] === 'admin' || user['custom:role'] === 'tournament_manager';
};

